import React from 'react';
import styles from './NotAvailableScreen.module.scss';
/* Translations */
import { tr } from '../../../../utils/translations/translator';
import { useTranslation } from 'react-i18next';

/* Assets */
import emptyImg from '../../../../assets/icons/shop/error-empty@3x.png';

interface NotAvailableScreenProps {
  title: string;
}

export const NotAvailableScreen: React.FC<NotAvailableScreenProps> = ({
  title,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <img alt="error-empty" src={emptyImg} />
      <h1>{title}</h1>
      <p>{tr(t, 'emptyState_go-to-app')}</p>
      <a href={'https://www.tipsterchat.com/store'} target="blank">
        <label>{tr(t, 'download_app')}</label>
      </a>
    </div>
  );
};
